import type { ReactNode } from 'react';
import { Button, EmptyState, Page } from '@/ds';
import { DocumentTitle } from '@/app/title';

/** A page this person may not open. Says nothing about what's behind it. */
export function NoAccess({
  title = "You don't have access to this page",
  children,
}: {
  title?: string;
  children?: ReactNode;
}) {
  return (
    <Page narrow>
      <DocumentTitle>No access</DocumentTitle>
      <div className="rq-panel">
        <EmptyState
          kind="error"
          title={title}
          action={
            <Button size="sm" href="/">
              Go to your start page
            </Button>
          }
        >
          {children}
        </EmptyState>
      </div>
    </Page>
  );
}
